import { tokens } from '../theme/theme';

export const SEVERITY_ORDER = ['critical', 'high', 'medium', 'low', 'info'];

export function severityLabel(level) {
  if (!level) return 'Info';
  return level.charAt(0).toUpperCase() + level.slice(1);
}

export function severityColor(level) {
  switch ((level || '').toLowerCase()) {
    case 'critical': return tokens.severity.critical;
    case 'high': return tokens.severity.high;
    case 'medium': return tokens.severity.medium;
    case 'low': return tokens.severity.low;
    default: return tokens.severity.info;
  }
}

export function severityChipSx(level) {
  const color = severityColor(level);
  return {
    color,
    borderColor: color,
    backgroundColor: `${color}1A`,
    border: '1px solid'
  };
}

export function formatRelativeTime(isoString) {
  if (!isoString) return '—';
  const parsed = new Date(isoString).getTime();
  if (Number.isNaN(parsed)) return '—';
  const diffMs = Date.now() - parsed;
  const future = diffMs < 0;
  const absMins = Math.floor(Math.abs(diffMs) / 60000);
  const suffix = future ? (unit) => `in ${unit}` : (unit) => `${unit} ago`;
  if (absMins < 1) return 'just now';
  if (absMins < 60) return suffix(`${absMins}m`);
  const hrs = Math.floor(absMins / 60);
  if (hrs < 24) return suffix(`${hrs}h`);
  const days = Math.floor(hrs / 24);
  return suffix(`${days}d`);
}

export function formatClock(isoString) {
  return new Date(isoString).toLocaleTimeString('en-GB', { hour12: false });
}
